export default "__VITE_ASSET__JxIjtfkz__"